/**
 * Eén set klassen voor velden, knoppen en lijsten in het beheer (/be).
 * Pure strings, zonder React. Hulpfuncties voor bewerken staan in admin/editing.ts.
 */

/** Eén stijl voor elk invoerveld in het beheer. */
export const inputCls =
  'w-full rounded-md border border-line bg-white px-3 py-2.5 text-[16px] text-ink sm:py-2 sm:text-[14px] placeholder:text-muted transition-colors duration-150 ease-soft hover:border-ink/30 focus:border-clay focus:outline-none focus:ring-2 focus:ring-clay/15 disabled:bg-sand disabled:text-muted'

export const btnPrimary =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-[14px] text-shell transition-colors duration-150 ease-soft hover:bg-clay disabled:cursor-not-allowed disabled:bg-ink/40'

export const btnSecondary =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-ink/15 bg-white px-5 py-2.5 text-[14px] text-ink transition-colors duration-150 ease-soft hover:border-ink'

export const btnGhost =
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-1.5 text-[13px] text-muted transition-colors duration-150 ease-soft hover:bg-sand hover:text-ink'

/** Oude cijfers blijven staan, iets lichter, terwijl de nieuwe laden (geen lege flits bij elk filter). */
export const fadeWhileLoading = (loading: boolean) =>
  `transition-opacity duration-150 ease-soft ${loading ? 'opacity-60' : ''}`

/**
 * Iets dat niet terug te draaien is (een bestelling annuleren). Bewust geen volle knop: rustig, maar
 * in een andere kleur en apart van de gewone acties, zodat het nooit per ongeluk de eerste keus is.
 */
export const btnDestructive =
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2.5 text-[14px] text-clay transition-colors duration-150 ease-soft hover:bg-blush/50'

/** Klein knopje met alleen een icoon (verplaatsen, weghalen). Altijd met een aria-label. */
export const btnIcon =
  'rounded p-2.5 text-muted transition-colors duration-150 ease-soft hover:bg-sand hover:text-ink disabled:opacity-30 sm:p-1.5'

/** Wit kader om een lijst met rijen. */
export const listBox = 'divide-y divide-line overflow-hidden rounded-lg border border-line bg-white'

/** Eén klikbare rij in een lijst — overal dezelfde maat. */
export const rowLink = 'flex items-center gap-4 px-4 py-4 transition-colors duration-150 ease-soft hover:bg-shell sm:px-5'
